import {
    GET_LIST_PARTNER_REQUEST,
    GET_LIST_PARTNER_SUCCESS,
    GET_LIST_PARTNER_FAILED
} from '../../actionTypes'

const initialState = {
    data:[],
    error: '',
    isLoading: false
}

const listPartnerReducer = (state = initialState, action) =>{
    switch (action.type) {
        case GET_LIST_PARTNER_REQUEST:
            return {
                ...state,
                isLoading:true,
            }
        case GET_LIST_PARTNER_SUCCESS:
            return {
                ...state,
                isLoading:false,
                data: action.payload
            }
        case GET_LIST_PARTNER_FAILED:
            return {
                ...state,
                isLoading:false,
                error: action.error
            }
    
        default:
            return state;
    }
}

export default listPartnerReducer;